// Private symbol to avoid collisions & keep internals hidden
const PENDING = Symbol('pendingCalls');

/**
 * Add (or overwrite) a pending method call.
 * Keeps only the latest call per method.
 * Accepts a cancel function called when the method is overridden.
 *
 * @param {Object} instance
 * @param {Function} method
 * @param {Array} args
 * @param {Function} cancel
 */
export function addToPending(instance, method, args = [], cancel = () => {}) {
  if (!instance[PENDING]) {
    // eslint-disable-next-line no-param-reassign
    instance[PENDING] = new Map();
  }

  const queue = instance[PENDING];

  const previous = queue.get(method);
  if (previous && typeof previous.cancel === 'function') {
    previous.cancel();
  }

  queue.set(method, {
    fn: method.bind(instance),
    args,
    cancel,
  });
}

/**
 * Execute all pending calls (latest per method only)
 */
export function executePending(instance) {
  const queue = instance[PENDING];
  if (!queue || queue.size === 0) return;

  Array.from(queue.values()).forEach(({ fn, args }) => {
    try {
      fn(...args);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    }
  });

  queue.clear();
}

/**
 * Clear pending calls without executing
 */
export function clearPending(instance) {
  const queue = instance[PENDING];
  if (queue) queue.clear();
}
